<template>
  <notification
    type="mention"
    :notification="notification"
    @notification-click="$emit('notification-click', $event)"
  >
    <template slot="context-content" v-if="showPreview">
      <div class="mt-3 text-content" v-no-capture>
        <deleted-entity v-if="isContextDeleted" />
        <template v-else>
          {{ textContent }}
        </template>
      </div>
    </template>
  </notification>
</template>

<script>
import DeletedEntity from '@/components/notifications/DeletedEntity'
import * as R from 'ramda'
import Notification from '@/components/notifications/Notification'
import convertHTMLToPlainText from '@/utils/convertHTMLToPlainText'

const notificationTypes = {
  initiativeDescriptionMention: 'initiative-description-mention',
  initiativeCommentMention: 'initiative-comment-mention',
  goalCommentMention: 'goal-comment-mention'
}

/**
 * This is the component for rendering a mention's notification
 */
export default {
  name: 'MentionNotification',
  props: {
    notification: Object,
    showPreview: Boolean
  },
  components: {
    Notification,
    DeletedEntity
  },
  computed: {
    // Path at which markup(comment/description) will be found in notification object
    markupPath() {
      switch (this.notification.type) {
        case notificationTypes.initiativeDescriptionMention:
          return ['data', 'initiative', 'description']
        default:
          return ['data', 'event', 'comment']
      }
    },
    isContextDeleted() {
      switch (this.notification.type) {
        case notificationTypes.initiativeDescriptionMention:
          return R.isNil(this.notification.data.initiative)
        default:
          return R.isNil(this.notification.data.event)
      }
    },
    textContent() {
      const markup = R.path(this.markupPath, this.notification)
      return convertHTMLToPlainText(markup)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .text-content {
  @include lineClamp(2);
}
</style>
